<small style="display: none">{{ appVersion }}</small>
<router-outlet />
